import { Constants } from "../constants/Contants";
import request from "../utils/useApi";

export const getAllUnreadNotifications = async () => {
  try {
    const res = await request.get(Constants.get_all_notification_api_url);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const updateNotification = async (id, data) => {
  try {
    const res = await request.patch(`${Constants.update_notification_api_url}/${id}`, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};